/**
 * Preserve Travel Admin snowflake IDs that exceed Number.MAX_SAFE_INTEGER.
 * Axios default JSON.parse rounds 15+ digit ids before React sees them.
 *
 * openCase returns raw MySQL maps keyed by `id` (not caseId), so we quote any
 * 15+ digit JSON number, not only known camelCase field names.
 */
const LARGE_INT_PATTERN = /(:\s*)(\d{15,})(\s*(?=[,\}\]]))/g;

export function parseTravelAdminJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(LARGE_INT_PATTERN, '$1"$2"$3');
  return JSON.parse(text);
}

export const travelAdminJson = { transformResponse: [parseTravelAdminJson] };
